export default __webpack_public_path__ + "static/media/ash-full-double.54ad51a6.jpg";